<nav class="sidebar-menu" aria-label="Sidebar menu">
  @for (item of items(); track item.id) {
    <div class="sidebar-menu__item">
      <button
        type="button"
        class="sidebar-menu__trigger"
        [class.sidebar-menu__trigger--active]="item.active"
        [attr.aria-expanded]="item.children?.length ? isExpanded(item) : null"
        (click)="onItemClick(item)"
      >
        @if (item.svgIcon) {
          <ocp-themed-icon [name]="item.svgIcon" class="sidebar-menu__icon" />
        }
        <span class="sidebar-menu__label" ocpTruncate>{{ item.label | translate }}</span>
      </button>

      @if (item.children?.length && isExpanded(item)) {
        <ul class="sidebar-menu__children">
          @for (child of item.children; track child.id) {
            <li>
              <button type="button" class="sidebar-menu__child" (click)="onChildClick(child)">
                <span class="sidebar-menu__child-label" ocpTruncate>{{ child.label }}</span>
              </button>
            </li>
          }
        </ul>
      }
    </div>
  }
</nav>

@if (showSeparator()) {
  <hr class="sidebar-menu__separator" />
}
